var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.text) ? _c('span', {
    staticClass: "text-placeholder"
  }, [_vm._v(_vm._s(_vm.text))]) : _c('span', {
    staticClass: "text-placeholder"
  }, [_vm._v("—")])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b70cedb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/TextPlaceholder.vue
// module id = 1914
// module chunks = 0